import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/core/get/get.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/val/val.js";
import "dabbyjs/src/traversal/closest/closest.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/events/trigger/trigger.js";
import error from "./error.js";
import {getfiles} from "./table.js";

export default (obj, config) => {
	if (obj.length) {
		$("#hashform-scrape").on("click", () => {
			const loader = "download__loader",
				cls = "hashform__item",
				container = obj.closest("." + cls),
				loadcls = cls + "--loading",
				form = obj.get(0).form,
				post = new FormData(form);

			// show a loader
			obj.addClass(loader);
			container.addClass(loadcls);

			// request a scrape
			post.append("action", "scrape");
			fetch($(form).attr("action") || location.href, {
				method: "POST",
				headers: {
					Accept: "application/json"
				},
				body: post
			})
				.then(response => {
					if (response.status >= 500) {
						throw new Error();
					}
					return response.json();
				})
				.then(json => {
					if (json.error) {
						error(container, json.msg);
					} else {
						const files = getfiles();

						// skip URL's that are already in the case, as the user can scrape more than once
						json.urls.forEach(url => {
							if (files.every(item => item.url !== url.url)) {
								files.push(url);
							}
						});
						$("#hashform-tags").prop("checked", true).trigger("change");
					}
				})
				.catch(() => {
					error(container, config.error);
				})
				.finally(() => {
					obj.removeClass(loader);
					container.removeClass(loadcls);
				});
		});
	}
};